<template>
    <div v-if="visible" class="admin-shortcut" :class="{ 'admin-shortcut--mobile': isMobile }">
        <button class="admin-shortcut-btn" @click="goToAdmin">
            <v-icon size="16">mdi-shield-account-outline</v-icon>
            <span class="admin-shortcut-label">Panel admin</span>
        </button>
        <button class="admin-shortcut-close" @click="dismiss">
            <v-icon size="14">mdi-close</v-icon>
        </button>
    </div>
</template>

<script>
import moment from 'moment'
import { isAdminEmail } from '@/utils/Admin'

const STORAGE_KEY = 'builder_admin_shortcut_hidden'

export default {
    name: 'AdminShortcut',
    data() {
        return {
            dismissed: false,
        }
    },
    computed: {
        visible(vm = this) {
            return !vm.dismissed && isAdminEmail()
        },
    },
    created() {
        const today = moment().format('YYYY-MM-DD')
        this.dismissed = localStorage.getItem(STORAGE_KEY) === today
    },
    methods: {
        goToAdmin() {
            this.pushRoute({ name: 'admin.home' })
        },
        dismiss() {
            this.dismissed = true
            localStorage.setItem(STORAGE_KEY, moment().format('YYYY-MM-DD'))
        },
    },
}
</script>

<style scoped>
.admin-shortcut {
    position: fixed;
    left: 72px;
    bottom: 16px;
    z-index: 6;
    display: flex;
    align-items: center;
    height: 36px;
    border-radius: 18px;
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline2-base);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.28);
    overflow: hidden;
}

.admin-shortcut--mobile {
    left: 12px;
    bottom: calc(64px + var(--safe-area-inset-bottom, 0px));
}

.admin-shortcut-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 100%;
    padding: 0 12px;
    color: var(--v-txtSecondary-base);
    font-size: 12px;
    font-weight: 700;
}

.admin-shortcut-btn:hover {
    background: var(--v-surface2-base);
    color: var(--v-txtPrimary-base);
}

.admin-shortcut-btn .v-icon {
    color: var(--v-accent-base);
}

.admin-shortcut-close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 100%;
    border-left: 1px solid var(--v-outline-base);
    color: var(--v-txtMuted-base);
}

.admin-shortcut-close:hover {
    background: var(--v-surface2-base);
    color: var(--v-error-base);
}
</style>
